<template>
  <Pie
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Pie } from "vue-chartjs/legacy";
import ChartDataLabels from "chartjs-plugin-datalabels";
// import labels from "chartjs-plugin-labels"
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from "chart.js";

// ChartJS.plugins.register({
//   id: 'paddingBelowLegends',
//   beforeInit: function(chart, options) {
//     chart.legend.afterFit = function() {
//       this.height = this.height + 50;
//     };
//   }
// });
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

export default {
  name: "PieChartNew",
  components: {
    Pie,
  },
  props: {
    datasets: {
      type: Array,
    },
    labels: {
      type: Array,
    },
    chartId: {
      type: String,
      default: "pie-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [
        {
          id: "paddingBelowLegends",
          beforeInit(chart) {     
            // Get reference to the original fit function     
            const originalFit = chart.legend.fit;      
              // Override the fit function     
            chart.legend.fit = function fit() {       
              // Call original function 
              // and bind scope in order to use `this` correctly inside it       
              originalFit.bind(chart.legend)();       
              // Change the height as suggested in another answers       
              this.height += 30;     
            }   
          } 
        }, 
        ChartDataLabels,
      ],
    },
  },
  data() {
    return {
      chartData: {
        labels: this.labels,
        datasets: this.datasets,
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        radius: '95%',
        plugins: {
          legend: {
            padding: 10,
            position: "top",
            align: "center",
          },
        },
      },
    };
  },
};
</script>